const getStageSlice = state => state.get('stage');

export const getZoomScale = state => getStageSlice(state).get('zoomScale');

export const getCurrentPieceID = state =>
  getStageSlice(state).get('currentPieceID');
